var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "8 8 24 24",
    enableBackground: "new 8 8 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.364,8v19.637H32V8H12.364z M29.382,25.019h-14.4v-14.4h14.4V25.019z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "19.4,22.452 25.018,16.834 25.018,20.218 27.637,20.218 27.637,12.364 19.782,12.364  19.782,14.982 23.167,14.982 17.548,20.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "10.618,22.4 8,22.4 8,32 17.6,32 17.6,29.382 10.618,29.382  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpen);
export default __webpack_public_path__ + "static/media/open.fedb9fed0292c94d7e150cf31098889f.svg";
export { ForwardRef as ReactComponent };